<template>
  <div class="platformAnnouncement">
   <!-- 平台公告 -->
   <card-plate title="平台公告">
      <span slot="headMore" @click="toPath('/notification')"><span>更多>></span></span>
      <ul slot="headCont" class="list">
        <li :key="item.noticeInfoId" v-for="item in noticeDtos||[]" @click="toPath('/notificationDetails',{'noticeId':item.noticeInfoId})"><div class="mr8 flex"><img v-if="item.viewNumber!='0'" src="../../../assets/images/gg_icon.svg" alt=""><img v-if="item.viewNumber=='0'" src="../../../assets/images/gg_icon2.svg" alt=""></div><div>{{item.noticeTitle}}</div></li>
        <!-- <li><span class="mr8"><img src="../../../assets/images/gg_icon.svg" alt=""></span><span>【重要通知】采招系统更新公告</span></li>
        <li><span class="mr8"><img src="../../../assets/images/gg_icon.svg" alt=""></span><span>【限时免费】一链网“商机匹配”上线公告</span></li>
        <li><span class="mr8"><img src="../../../assets/images/gg_icon.svg" alt=""></span><span>【重要通知】端午节休假通知</span></li>
        <li><span class="mr8"><img src="../../../assets/images/gg_icon.svg" alt=""></span><span>【限时免费】一链网“福星购”上线公告</span></li> -->
        <empty-tab v-if="(noticeDtos&&noticeDtos.length==0)||!noticeDtos"></empty-tab>
      </ul>
   </card-plate>
  </div>
</template>
<script>
import cardPlate from './cardPlate.vue'
import emptyTab from './emptyTab.vue'
export default {
  props: ['noticeDtos'],
  components: {
    'card-plate': cardPlate,
    'empty-tab': emptyTab
  },
  data () {
    return {
    }
  },
  created () {
    
  },
  methods: {
    toPath(url,params){
      // 公告跳转  http://test.onelinkplus.com/notificationDetails?noticeId=5864132221366960128
      
      let routeData = this.$router.resolve({
        path: url,
        query:params
      });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>
<style>

.platformAnnouncement .mr8{
  margin-right:8px;
}
.platformAnnouncement .flex{
  display: flex;
}

.platformAnnouncement .cardPlate-cont{
  max-height: 265px;
  overflow: auto;
}
.platformAnnouncement .cardPlate-cont::-webkit-scrollbar {
  width: 8px;
  height: 10px;
}

.platformAnnouncement .cardPlate-cont::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}

.platformAnnouncement .cardPlate-cont::-webkit-scrollbar-thumb {
  -webkit-border-radius: 4px;
  border-radius: 4px;
  background: rgba(0,0,0,0.3);
}

.platformAnnouncement .cardPlate-cont::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0,0,0,0.2);
}
</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/platformAnnouncement.vue